/**
 * Filter Configuration
 * Defines filter options for all tables
 */

// Orders Filters
export const ORDERS_FILTERS = [
  { id: 'clientName', label: 'Client Name', type: 'text' },
  { id: 'location', label: 'Location', type: 'text' },
  { id: 'status', label: 'Status', type: 'select' },
  { id: 'quotationNumber', label: 'Quotation Number', type: 'text' },
  { id: 'dateRange', label: 'Date Range', type: 'dateRange' }
];

// Quotations Filters
export const QUOTATIONS_FILTERS = [
  { id: 'clientName', label: 'Client Name', type: 'text' },
  { id: 'location', label: 'Location', type: 'text' },
  { id: 'status', label: 'Status', type: 'select' },
  { id: 'quotationNumber', label: 'Quotation Number', type: 'text' },
  { id: 'dateRange', label: 'Date Range', type: 'dateRange' }
];

// Enquiries Filters
export const ENQUIRIES_FILTERS = [
  { id: 'client_id', label: 'Client', type: 'clientAutocomplete' },
  { id: 'city', label: 'City', type: 'select' },
  { id: 'state', label: 'State', type: 'select' },
  { id: 'status', label: 'Status', type: 'select' },
  { id: 'enquiryNumber', label: 'Enquiry Number', type: 'text' },
  { id: 'dateRange', label: 'Date Range', type: 'dateRange' }
];

